import React, { Component } from "react";

class DateSelectInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: "",
      selectedMonth: "",
      selectedYear: "",
    };
  }

  handleDateChange = (event) => {
    this.setState({ selectedDate: event.target.value });
    this.props.dayOnchange(event.target.value);
  };

  handleMonthChange = (event) => {
    this.setState({ selectedMonth: event.target.value });
    this.props.monthOnchange(event.target.value);
  };

  handleYearChange = (event) => {
    this.setState({ selectedYear: event.target.value });
    this.props.yearOnchange(event.target.value);
  };

  renderDayOptions = () => {
    const days = [];
    for (let day = 1; day <= 31; day++) {
      days.push(
        <option key={day} value={day}>
          {day}
        </option>
      );
    }
    return days;
  };

  renderMonthOptions = () => {
    const months = [];
    for (let month = 1; month <= 12; month++) {
      months.push(
        <option key={month} value={month}>
          {month}
        </option>
      );
    }
    return months;
  };

  renderYearOptions = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100;
    for (let year = startYear; year <= currentYear; year++) {
      years.push(
        <option key={year} value={year}>
          {year}
        </option>
      );
    }
    return years;
  };

  render() {
    const { type } = this.props;
    const { selectedDate, selectedMonth, selectedYear } = this.props;

    return (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
        {type === 1 ? (
          <select
            className="w-100"
            value={selectedDate}
            onChange={this.handleDateChange}
          >
            <option value="">Day</option>
            {this.renderDayOptions()}
          </select>
        ) : type === 2 ? (
          <select
            className="w-100"
            value={selectedMonth}
            onChange={this.handleMonthChange}
          >
            <option value="">Month</option>
            {this.renderMonthOptions()}
          </select>
        ) : (
          <select
            className="w-100"
            value={selectedYear}
            onChange={this.handleYearChange}
          >
            <option value="">Year</option>
            {this.renderYearOptions()}
          </select>
        )}
      </div>
    );
  }
}

export default DateSelectInput;
